var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"height":"100vh"},attrs:{"src":((this.quoteUrlNew) + "/app/how-it-works?token=" + _vm.api_token + "&lang=" + (_vm.$i18n.locale) + "-" + (_vm.$i18n.locale === 'fr'
        ? _vm.$i18n.locale.toUpperCase()
        : _vm.$i18n.locale === 'en'
        ? 'GB'
        : 'SE')),"width":"100%","height":"100%","frameBorder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }